import { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { cn } from '../../lib/cn';

interface SecretBlockProps {
  value: string;
  onCopy?: () => void;
  className?: string;
}

export function SecretBlock({ value, onCopy, className }: SecretBlockProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      onCopy?.();
      window.setTimeout(() => setCopied(false), 1800);
    } catch {
      // clipboard unavailable
    }
  };

  return (
    <div className={cn('relative rounded-xl border border-border bg-surface-elevated', className)}>
      <pre className="m-0 max-h-72 overflow-auto whitespace-pre-wrap break-words rounded-xl px-4 py-3 pr-12 font-mono text-[0.95rem] leading-6 text-text">
        {value}
      </pre>
      <button
        type="button"
        onClick={handleCopy}
        aria-label={copied ? 'Copied' : 'Copy secret'}
        className="absolute right-2 top-2 inline-flex h-9 w-9 items-center justify-center rounded-lg text-text-muted hover:bg-surface hover:text-primary active:scale-[0.95] transition-colors"
      >
        {copied ? <Check size={18} className="text-accent" /> : <Copy size={18} />}
      </button>
    </div>
  );
}
